// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"c-CR3Xb","date":"UVa9X0"};